import { FC } from "react";
import classNames from "classnames/bind";
import { Text, Picture } from "@smile2impress/components/relaunch";
import { BlogPostShortProps } from "api/cms-website/cms-blog-posts.types";
import { useUTSLocaleContext } from "context/utsLocaleContext";
import { UTSLocaleToLanguage } from "@smile2impress/attraction-constants";

import { UrlsConfig } from "configs/urlsConfig";
import { formatDate } from "utils/date";
import Link from "components/Link";

import styles from "./BlogList.module.scss";

const cx = classNames.bind(styles);

interface BlogListProps {
    list: BlogPostShortProps[];
    readMoreText: string;
    readTimeText: string;
}

export const BlogList: FC<BlogListProps> = (props) => {
    const { list = [], readMoreText } = props;
    const { locale } = useUTSLocaleContext();

    return (
        <div className={cx("root")}>
            {list.map(
                ({ slug, publication_date, name, cover, content_preview }) => {
                    const href = UrlsConfig.BLOG_POST.replace("[id]", slug);
                    const language = UTSLocaleToLanguage[locale];
                    const formattedDate = formatDate(
                        new Date(publication_date),
                        "PPP",
                        language
                    );
                    const coverUrl =
                        cover.desktop?.url || cover.mobile?.url || "";
                    return (
                        <div className={cx("block")} key={slug}>
                            <Link href={href}>
                                <Picture
                                    display="block"
                                    maxW="100%"
                                    mb="20px"
                                    defaultSrc={coverUrl}
                                    loading="observer"
                                />
                                <Text
                                    textStyle="action"
                                    mb={1}
                                    dangerouslySetInnerHTML={{ __html: name }}
                                />
                                <Text
                                    textStyle="caption"
                                    mb={3}
                                    fontWeight="body"
                                >
                                    {formattedDate}
                                </Text>
                                <Text
                                    textStyle="caption"
                                    mb={3}
                                    fontWeight="body"
                                    dangerouslySetInnerHTML={{
                                        __html: content_preview,
                                    }}
                                />
                                <Text
                                    textStyle="caption"
                                    color="text.accent"
                                    textDecor="underline"
                                    fontWeight="body"
                                >
                                    {readMoreText}
                                </Text>
                            </Link>
                        </div>
                    );
                }
            )}
        </div>
    );
};
